module.exports = __webpack_public_path__ + "static/media/banner-aviso-pix.4ef71699.png";